import React from 'react';
import AntdInput, { InputProps } from 'antd/lib/input';

import './input.scss';

const { TextArea } = AntdInput;

interface Props extends InputProps {
	placeholder?: string;
	className?: string;
}

const Input = ({ placeholder, className, ...inputProps }: Props) => {
	return (
		<AntdInput
			className={`bringg-input ${className ? className : ''}`}
			placeholder={placeholder || ''}
			{...inputProps}
		/>
	);
};
const InputPassword = ({ placeholder, className, ...inputProps }: Props) => {
	return (
		<AntdInput.Password
			className={`bringg-input ${className ? className : ''}`}
			placeholder={placeholder || ''}
			{...inputProps}
		/>
	);
};

export { TextArea, InputPassword };
export default Input;
